module.exports = __webpack_public_path__ + "img/f03943e.png";